import { useFiltersLists } from "features/filters/store/lists";

const useOrdensDeServicoAbertaFilters = () => {

  const { ordensDeServicosAbertas, loadings } = useFiltersLists();

  return {
    isLoading: loadings.ordensDeServicosAbertas,
    ordensDeServicosAbertas,
  };
};

export default useOrdensDeServicoAbertaFilters;
